import {
  DepositOptionSelection,
  DepositPolicyChargesResponse,
  DepositSelectionResponse,
} from '@common/entities';
import { get, post } from 'config/api/config';

export const getDepositPolicyCharges = async (
  cid: number,
  propertyId: number,
  leaseId: number,
): Promise<DepositPolicyChargesResponse> => {
  const params = new URLSearchParams({
    cid: cid.toString(),
    propertyId: propertyId.toString(),
    leaseId: leaseId.toString(),
  });

  const response = await get<DepositPolicyChargesResponse>(
    `/viewer/deposit/policy-charges?${params}`,
  );
  return response.data;
};

export const saveDepositSelection = async (data: {
  cid: number;
  propertyId: number;
  leaseId: number;
  depositOption: DepositOptionSelection;
}): Promise<DepositSelectionResponse> => {
  const response = await post<DepositSelectionResponse>('/viewer/deposit/selection', data);
  return response.data;
};
